import "./precisions.css";
import React, { useState } from "react";
import { useContext } from "react";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { RISContext } from "./RISProvider";
import InfoMessage from "components/ui/controls/info-message/info-message";
import { FaBriefcase, FaChartPie, FaHandsHelping, FaLandmark, FaStore } from "react-icons/fa";

const PrecisionsRIS = (props) => {
  const RIS = useContext(RISContext);
  const [RSIChoiceAll, setRISChoiceAll] = useState("RsiCommercant");

  // console.log("PRECISE", RIS.InfosBlocageRIS);
  const carriereRSI = [
    {
      value: "RsiCommercant",
      label: "Commerçant",
    },
    {
      value: "RsiArtisan",
      label: "Artisan",
    },
    {
      value: "Ravgdt",
      label: "Débitant de tabac",
    },
  ];

  const absencePointRGSelect = [
    {
      value: "SalarieNonCadre",
      label: "Salarié non cadre du  secteur privé",
    },
    {
      value: "SalarieCadre",
      label: "Salarié cadre du  secteur privé",
    },
    {
      value: "SalarieNonCadreCFE",
      label: "Salarié non cadre cotisant CFE",
    },
    {
      value: "SalarieCadreCFE",
      label: "Salarié cadre cotisant CFE",
    },
    {
      value: "SalarieNonCadreAgricole",
      label: "Salarié non cadre du secteur agricole",
    },
    {
      value: "SalarieCadreAgricole",
      label: "Salarié cadre du secteur agricole",
    },
    {
      value: "SalarieIrcantec",
      label: "Salarié non titulaire de l’Etat",
    },
  ];

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            {Boolean(RIS.InfosBlocageRIS.AbsencePointRG) === true && (
              <>
                <Row>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaBriefcase />}>
                    Précision sur une période
                  </CardBoxHeader>
                </Row>
                <Row>
                  <InfoMessage
                    text={
                      <>
                        Le logiciel a détecté une periode d'activité au régime général en {new Date().getFullYear() - 1} sans affiliation à un régime complémentaire. Merci de préciser la
                        nature de l'activité :
                      </>
                    }
                  />
                </Row>
                <Row tpad>
                  <DropDown
                    label="Nature de l'activité"
                    value={RIS.InfosBlocageRIS.AbsencePointRG}
                    onChange={(e) => {
                      RIS.handleCorrectionBlocageRIS("AbsencePointRG", "", "", e);
                    }}
                    options={absencePointRGSelect}
                    normal
                  />
                </Row>
              </>
            )}
            {Boolean(RIS.InfosBlocageRIS.PeriodeCnavpl) === true && (
              <>
                <Row>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaBriefcase />}>
                    Période d’affiliation à un régime de profession libérale
                  </CardBoxHeader>
                </Row>
                <Row>
                  <InfoMessage
                    text={
                      <>
                        Le logiciel a détecté une période d’affiliation au régime de base des professions libérales ou au régime de base des avocats. Nous vous rappelons que dans le cadre de
                        ces régimes (hors CIPAV), l'entrée en jouissance de la pension de retraite est fixée au 1<sup>er</sup> jour du trimestre civil qui suit la demande. Dès lors, le
                        logiciel fixe automatiquement un départ au 1<sup>er</sup> jour d'un trimestre civil. Si vous souhaitez modifier l'âge de départ en retraite,
                        <b>
                          nous vous conseillons vivement de fixer la date à un 1<sup>er</sup> jour de trimestre civil.
                        </b>
                      </>
                    }
                  />
                </Row>
              </>
            )}
            {Boolean(RIS.InfosBlocageRIS.AidantFamilial) === true && (
              <>
                <Row>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaHandsHelping />}>
                    Aidant familial à la MSA
                  </CardBoxHeader>
                </Row>
                <Row>
                  <InfoMessage
                    text={
                      <>
                        Le logiciel a détecté une période d’affiliation à la MSA en tant qu’aidant familial. Nous vous informons que le statut n’est pas intégré à ce jour dans le simulateur.
                        N’hésitez pas à nous contacter si vous souhaitez des informations complémentaires.
                      </>
                    }
                  />
                </Row>
              </>
            )}
            {Boolean(RIS.InfosBlocageRIS.CotisAssi) === true && (
              <>
                <Row>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaChartPie />}>
                    Précisions sur la répartition des trimestres
                  </CardBoxHeader>
                </Row>
                <Row>
                  <InfoMessage
                    text={
                      <>
                        Le logiciel a détecté une ou plusieurs années au cours de laquelle ont été comptabilisés des trimestres cotisés et assimilés. Par défaut, le logiciel détermine le
                        montant des trimestres cotisés en fonction du salaire retenu sur l'année et compare les trimestres calculés avec le total des trimestres indiqués sur l'année. La
                        différence est affectée aux trimestres assimilés. Vous pouvez toutefois modifier cette répartition en cliquant directement sur les trimestres cotisés ou assimilés. En
                        présence de périodes de maladie, maternité, invalidité, le logiciel attribue par défaut les trimestres à la prestation maladie. Vous pouvez modifier ce choix dans le
                        tableau ci-dessous en cliquant directement sur les trimestres cotisés ou assimilés.
                      </>
                    }
                  />
                </Row>
                <Row tpad bpad>
                  <div className="trimester-container">
                    <Column fill>
                      {/* Column headers for the list */}
                      <div className="trimester-headers">
                        <span className="header-year">Année</span>
                        <span className="header-regime-general">Régime général</span>
                        <span className="header-ssi">SSI</span>
                        {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroRSI")).length > 0 && (
                          <span className="header-micro">Micro RSI</span>
                        )}
                        {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroBIC")).length > 0 && (
                          <span className="header-micro">Micro BIC</span>
                        )}
                        {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroBNC")).length > 0 && (
                          <span className="header-micro">Micro BNC</span>
                        )}
                        <span className="header-avpf">AVPF</span>
                        <span className="header-chomage">Chômage</span>
                        <span className="header-maladie">Maladie</span>
                        <span className="header-maternite">Maternité</span>
                        <span className="header-invalidite">Invalidité</span>
                        <span className="header-militaire">Militaire</span>
                        <span className="header-retenus">Trim. retenus</span>
                      </div>
                      <ul className="trimester-list">
                        {Object.entries(RIS.InfosBlocageRIS.CotisAssi).map((data, index) => {
                          return (
                            <li key={"Blocage" + index} className="trimester-row">
                              <span className="trimester-year-badge">{data[0]}</span>
                              <div className="trimester-field trimester-field-regime-general">
                                {data[1].find((Liste) => Liste.Regime === "RegimeGeneral") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "RegimeGeneral").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "RegimeGeneral"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-ssi">
                                {data[1].find((Liste) => Liste.Regime === "RSICommercant") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "RSICommercant").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "RSICommercant"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroRSI")).length > 0 && (
                                <div className="trimester-field trimester-field-micro">
                                  {data[1].find((Liste) => Liste.Regime === "MicroRSI") && (
                                    <TextField
                                      className="center"
                                      value={data[1].find((Liste) => Liste.Regime === "MicroRSI").Trimestres}
                                      onChange={(e) => {
                                        RIS.handleCorrectionBlocageRIS(
                                          "CotisAssi",
                                          data[0],
                                          data[1].findIndex((Liste) => Liste.Regime === "MicroRSI"),
                                          e
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                              {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroBIC")).length > 0 && (
                                <div className="trimester-field trimester-field-micro">
                                  {data[1].find((Liste) => Liste.Regime === "MicroBIC") && (
                                    <TextField
                                      className="center"
                                      value={data[1].find((Liste) => Liste.Regime === "MicroBIC").Trimestres}
                                      onChange={(e) => {
                                        RIS.handleCorrectionBlocageRIS(
                                          "CotisAssi",
                                          data[0],
                                          data[1].findIndex((Liste) => Liste.Regime === "MicroBIC"),
                                          e
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                              {Object.entries(RIS.InfosBlocageRIS.CotisAssi).filter((i) => i[1].find((carriere) => carriere.Arr === "CarriereMicroBNC")).length > 0 && (
                                <div className="trimester-field trimester-field-micro">
                                  {data[1].find((Liste) => Liste.Regime === "MicroBNC") && (
                                    <TextField
                                      className="center"
                                      value={data[1].find((Liste) => Liste.Regime === "MicroBNC").Trimestres}
                                      onChange={(e) => {
                                        RIS.handleCorrectionBlocageRIS(
                                          "CotisAssi",
                                          data[0],
                                          data[1].findIndex((Liste) => Liste.Regime === "MicroBNC"),
                                          e
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                              <div className="trimester-field trimester-field-avpf">
                                {data[1].find((Liste) => Liste.Regime === "Avpf") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Avpf").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Avpf"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-chomage">
                                {data[1].find((Liste) => Liste.Regime === "Chomage") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Chomage").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Chomage"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-maladie">
                                {data[1].find((Liste) => Liste.Regime === "Maladie") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Maladie").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Maladie"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-maternite">
                                {data[1].find((Liste) => Liste.Regime === "Maternite") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Maternite").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Maternite"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-invalidite">
                                {data[1].find((Liste) => Liste.Regime === "Invalidite") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Invalidite").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Invalidite"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-militaire">
                                {data[1].find((Liste) => Liste.Regime === "Militaire") && (
                                  <TextField
                                    className="center"
                                    value={data[1].find((Liste) => Liste.Regime === "Militaire").Trimestres}
                                    onChange={(e) => {
                                      RIS.handleCorrectionBlocageRIS(
                                        "CotisAssi",
                                        data[0],
                                        data[1].findIndex((Liste) => Liste.Regime === "Militaire"),
                                        e
                                      );
                                    }}
                                  />
                                )}
                              </div>
                              <div className="trimester-field trimester-field-retenus">
                                <TextField className="center" disabled value={data[1].find((Liste) => Liste.TrimestreRetenu >= 0).TrimestreRetenu} />
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </Column>
                  </div>
                </Row>
              </>
            )}
            {Boolean(RIS.InfosBlocageRIS.CarriereRSICommercant) === true && (
              <>
                <Row>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaStore />}>
                    Période d’affiliation à la sécurité sociale des indépendants
                  </CardBoxHeader>
                </Row>
                <InfoMessage
                  text={
                    <>
                      Le logiciel a détecté une ou plusieurs périodes d’affiliation à la sécurité sociale des indépendants. Merci de préciser s’il s’agit d’une affiliation en tant que
                      commerçant ou en tant qu’artisan.
                    </>
                  }
                />
                <Row tpad bpad>
                  <Column fill>
                    {/* Configuration globale */}
                    <div className="rsi-config-section">
                      <div className="rsi-config-row">
                        <span className="rsi-config-label">Définir la caisse pour toutes les années</span>
                        <div className="rsi-config-dropdown">
                          <DropDown
                            value={RSIChoiceAll}
                            onChange={(e) => {
                              setRISChoiceAll(e.target.value);
                              RIS.handleCorrectionBlocageRIS("CarriereRSICommercant", "", "RSIChoiceAll", e);
                            }}
                            options={carriereRSI}
                            normal
                          />
                        </div>
                      </div>
                    </div>

                    {/* Headers pour la liste des données */}
                    <div className="rsi-data-headers">
                      <span className="header-year">Année</span>
                      <span className="header-caisse">Caisse</span>
                    </div>

                    {/* Liste des données */}
                    <ul className="rsi-data-list">
                      {Object.entries(RIS?.InfosBlocageRIS?.CarriereRSICommercant).map((data, index) => {
                        return (
                          <li key={"RSI" + index} className="rsi-data-row">
                            <span className="rsi-year-badge">{data[0]}</span>
                            <div className="rsi-caisse-field">
                              <DropDown
                                value={data[1].Nature}
                                onChange={(e) => {
                                  RIS.handleCorrectionBlocageRIS("CarriereRSICommercant", data[0], "", e);
                                }}
                                options={carriereRSI}
                                normal
                                style={{ marginBottom: 0 }}
                              />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </Column>
                </Row>
              </>
            )}

            {Boolean(RIS.InfosBlocageRIS.CarriereFonctionPublique) === true && (
              <>
                <Row tpad>
                  <CardBoxHeader style={{ marginTop: 0 }} icon={<FaLandmark />}>
                    Période d’affiliation à la fonction publique
                  </CardBoxHeader>
                </Row>
                <Row tpad>
                  <InfoMessage
                    text={
                      <>
                        Le logiciel a détecté une période d’affiliation à la fonction publique. En l’absence de projection de la carrière sur le régime, nous vous rappelons qu’il est
                        indispensable de saisir le dernier salaire ou l’indice de fin de carrière sur la dernière période pour sa bonne prise en compte.
                      </>
                    }
                  />
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Salaire"
                      value={RIS.InfosBlocageRIS.CarriereFonctionPublique["Salaire"]}
                      onChange={(e) => {
                        RIS.handleCorrectionBlocageRIS("CarriereFonctionPublique", "", "Salaire", e);
                      }}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Indice de fin de carrière"
                      value={RIS.InfosBlocageRIS.CarriereFonctionPublique["IFC"]}
                      onChange={(e) => {
                        RIS.handleCorrectionBlocageRIS("CarriereFonctionPublique", "", "IFC", e);
                      }}
                      dataType="uint"
                      normal
                    />
                  </Column>
                </Row>
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default PrecisionsRIS;
